import BackCircle from '../svg/back-circle'

export default function InfoCard({ children, handleClick, isSlide, ...cardProps }) {
  return (
    <div className='wrapper flex' {...cardProps}>
      {children}

      {isSlide && (
        <button className='nextSlideBtn' onClick={handleClick}>
          <BackCircle />
        </button>
      )}

      <style jsx>{`
        .wrapper {
          position: relative;
          min-height: 49.7rem;
          margin: 0 1.2rem;
          border-radius: 1rem;
          overflow: hidden;
          background: #1a1e21;

          .nextSlideBtn {
            position: absolute;
            bottom: 4.25rem;
            right: 3.83rem;
            background: transparent;
          }

          :global(svg) {
            width: 3.666rem;
            height: 3.666rem;
            transform: rotate(180deg);
            pointer-events: none;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            flex-direction: column;
            min-height: unset;

            .nextSlideBtn {
              bottom: 2.28rem;
              right: 2.28rem;
            }

            :global(svg) {
              width: 2rem;
              height: 2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
